import PropTypes from 'prop-types'
import { useRef, useEffect } from 'react'
import useSlugs from '../../../hooks/useSlugs'
import { EnvConfig } from '../../../config/EnvConfig'
import { getWebsiteUrl } from '../../../utils/getWebsiteUrl'

const websiteURL = getWebsiteUrl()
const locale = EnvConfig.GATSBY_INTL_LOCALE

export const KambiScript = ({ pathname }) => {
  const isMountedRef = useRef(false)
  const getRouteRoot = () => {
    if (pathname.includes(`/${locale}/`)) {
      const [, localeParam, path] = pathname.split('/')
      return `${localeParam}/${path}`
    }

    return pathname.split('/')?.[1] || ''
  }
  const routeRoot = getRouteRoot()
  const [loginSlug, depositSlug] = useSlugs(['login', 'deposit'])
  const loginRoute = `${websiteURL}${loginSlug}`
  const depositRoute = `${websiteURL}${depositSlug}`

  const handleNotificationEvent = (data) => {
    const event = new CustomEvent('kambi-notification', { detail: data })
    window.dispatchEvent(event)
  }

  if (!loginSlug) return null

  // Ensure that the script only runs once
  useEffect(() => {
    if (isMountedRef.current) return

    isMountedRef.current = true

    // Append the script to the DOM
    const scriptContent = `
      (function (global) {
        const CustomerSettings = function () {
          this.enablePushState = true
          this.routeRoot = '${routeRoot}'
          this.loginUrl = '${loginRoute}'
          this.depositUrl = '${depositRoute}'
        }
        CustomerSettings.prototype.notification = ${handleNotificationEvent.toString()}
        global.customerSettings = new CustomerSettings()
      }(window))`

    const scriptElement = document.createElement('script')
    scriptElement.innerHTML = scriptContent
    document.body.appendChild(scriptElement)

    // Cleanup to remove script if necessary (optional)
    return () => {
      isMountedRef.current = false
      if (scriptElement.parentNode) {
        scriptElement.parentNode.removeChild(scriptElement)
      }
    }
  }, [routeRoot, loginRoute, depositRoute])

  // No need to return a <Script> component since the script is managed by useEffect
  return null
}

KambiScript.defaultProps = {
  pathname: '',
}

KambiScript.propTypes = {
  pathname: PropTypes.string,
}